<template>

	<g>
		<g ref="head">
			<g>
				<path fill="#FFCEB1" d="M11.7,6.1c-7.3,1.7-7.1,6.7-7.1,6.7s0.2,3.9,0.4,8.5c-0.7-0.9-1.8-1.3-3-0.8c-2.5,1.1-0.6,8.9,3.1,8.2
			c0.2,2.2,0.4,3.9,0.7,4.5c1.1,2.2,5.7,5.6,9.9,6.1c4.1,0.5,9.3-2.2,9.3-7.1s0.1-22.9,0.1-22.9S23.7,3.4,11.7,6.1z"/>

				<g ref="eye">
					<path fill="#1C1C24" d="M14,20.9c0,1.1-0.5,1.9-1.1,1.9s-1.1-0.9-1.1-1.9c0-1.1,0.5-1.9,1.1-1.9S14,19.8,14,20.9z"/>
					<path fill="#1C1C24" d="M22.9,21.3c0,1.1-0.5,1.9-1.1,1.9s-1.1-0.9-1.1-1.9c0-1.1,0.5-1.9,1.1-1.9S22.9,20.3,22.9,21.3z"/>
				</g>

				<g ref="duga">
					<g>
						<path fill="#8E6537" d="M15.7,16.5c0,0-0.5,0-1.1,0c-0.6,0-1.3,0-2,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.3,0-0.4,0.1
					c-0.3,0-0.6,0.1-0.8,0.3c-0.3,0.1-0.5,0.2-0.7,0.3c-0.2,0.1-0.3,0.1-0.3,0.1s0-0.1,0-0.3c0-0.2,0.1-0.5,0.3-0.8
					c0.1-0.2,0.2-0.3,0.4-0.5c0.1-0.2,0.3-0.3,0.5-0.4c0.2-0.1,0.4-0.2,0.7-0.3c0.2-0.1,0.5-0.1,0.7-0.1s0.5,0,0.7,0s0.5,0.1,0.7,0.2
					c0.4,0.1,0.8,0.3,1,0.6C15.5,16.1,15.7,16.5,15.7,16.5z"/>
					</g>
					<g>
						<path fill="#8E6537" d="M20,16.5c0,0,0.1-0.4,0.5-0.9c0.2-0.2,0.5-0.4,0.8-0.6c0.4-0.2,0.8-0.2,1.3-0.2c0.5,0.1,0.9,0.2,1.2,0.5
					c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.1,0.2,0.3,0.2,0.5c0.1,0.3,0.1,0.6,0.1,0.7c0,0.2,0,0.3,0,0.3s-0.1,0-0.3-0.1s-0.3-0.2-0.6-0.3
					c-0.1,0-0.2-0.1-0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.4-0.1-0.6-0.1c-0.4,0-1,0-1.5,0C20.5,16.5,20,16.5,20,16.5z"/>
					</g>
				</g>
				<path opacity="0.4" fill="#C87761" enable-background="new    " d="M2.3,21.8c1.3-0.7,2.4,1.4,2.5,3.7c-1.1-0.2-1.2,1.1-0.6,1.9
			C2,27.8,0.9,22.5,2.3,21.8z"/>
				<g>
					<path fill="#E69483" d="M18.5,18.9c0.1,0.3,0.3,0.6,0.4,0.9c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.6,0.3,1.3,0.5,1.9
				c0.1,0.6,0.2,1.3,0.3,1.9s0.2,1.3,0.3,1.9v0.1h-0.1c-0.8,0.4-1.6,0.7-2.4,1.1c0.7-0.5,1.5-0.9,2.3-1.3L20,26.5
				c-0.1-0.6-0.2-1.3-0.4-1.9c-0.1-0.6-0.2-1.3-0.3-1.9s-0.3-1.3-0.4-1.9c-0.1-0.3-0.1-0.6-0.2-1C18.6,19.5,18.6,19.2,18.5,18.9z"/>
				</g>
				<path fill="#8E6537" d="M25.1,10.6c1.5-0.2,4.3-3.2,3.2-6.4c0,0-0.3,1.7-2.7,1.7c0,0,1.4-0.5,1.6-1.4c0,0-1.7,1-5.7-1.4
			c-0.4-0.2-0.8-0.5-1.2-0.7c-0.6-0.3-1.2-0.6-1.9-0.8C13.8-0.2,7.2-0.8,4.9,7.8C4.8,8.1,4.8,8.3,4.8,8.3S1.6,8,1.6,13.4
			c0,2.1,0.8,4.2,1.8,6.8c1,0.1,1.6,1.5,1.6,1.5l0.5,3.5c0,1-0.1,2.6-0.4,3.4c-0.5,1.3-1.2,7.2,6.6,10.2s15-0.1,13.2-10.3
			c0,0,0.2,2.7-1.1,2.4c-1.2-0.3-0.1-3.9-6-3.2c-1.9-0.2-4.4-1.7-6.4,1.8c-1.6,2.8-4.6,0.9-4.8-6.1v-1.8c0-0.1,0-0.2,0-0.3l0,0v-4.8
			c0,0,2.2-1.9,2.4-4.5c14.3,5.5,18.7-1.5,18.7-1.5S26.8,11,25.1,10.6z M12.9,30.1c3.1,0.9,5.3-0.3,5.3-0.3c1.8,1.4,4.1,1.3,4.1,1.3
			c0.3,0.4,1.3,3.5-2,4.7s-2.5-2.4-2.5-2.4l-1.3-0.2c0,0,0.5,2.8-2.4,2.5C9.9,35.3,12.9,30.1,12.9,30.1z"/>
				<path fill="#FFFFFF" d="M12.8,30.5c0,0,4.6,6.3,8.9,1.5L12.8,30.5"/>
			</g>
			<path fill="#353F48" d="M-3.7,44.7"/>
		</g>
	</g>

</template>

<script>

	import { TimelineMax } from 'gsap'

	export default {
		data: function () {
			return {
				tl:undefined,
				tl2: undefined,
				tl3: undefined,
			}
		},
		mounted() {
			this.tl = new TimelineMax({repeat:-1});
			this.tl2 = new TimelineMax({repeat:-1});
			this.tl3 = new TimelineMax({repeat:-1});
		},
		methods: {
			start() {
				var eye = this.$refs.eye;
				var duga = this.$refs.duga
				var head = this.$refs.head

				this.tl.to(eye, 0.25, {scaleY:0, transformOrigin:"0% 50%"});
				this.tl.to(eye, 0.25, {scale:1, transformOrigin:"100% 50%"});
				this.tl.to(eye, 3.5, {scale:1, transformOrigin:"100% 50%"});

				this.tl2.set(duga,{y:0.5})
				this.tl2.to(duga,0.25,{y:-0.05})
				this.tl2.to(duga,0.25,{y:0.05})
				this.tl2.to(duga,3.5,{y:0.5})

				this.tl3.set(head,{rotation: -2, transformOrigin:"center"})
				this.tl3.to(head, 2, {rotation: +2, transformOrigin:"center"})
				this.tl3.to(head, 2, {rotation: -2, transformOrigin:"center"})
			},
			stop() {
				this.tl.kill();
				this.tl2.kill();
				this.tl3.kill();
			},
			pause() {
				this.tl.pause();
				this.tl2.pause();
				this.tl3.pause();
			},
			play() {
				this.tl.play();
				this.tl2.play();
				this.tl3.play();
			}
		}
	}

</script>

<style lang="scss">



</style>
